import { createRefContext } from './RefContext';

export const { RefContext: TooltipContainerContext, RefProvider: TooltipContainerRef } =
  createRefContext<HTMLDivElement>('TooltipContainerContext');
